import { render, staticRenderFns } from "./PopupDetail.vue?vue&type=template&id=d50c43c2&scoped=true"
import script from "./PopupDetail.vue?vue&type=script&lang=js"
export * from "./PopupDetail.vue?vue&type=script&lang=js"
import style0 from "./PopupDetail.vue?vue&type=style&index=0&id=d50c43c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50c43c2",
  null
  
)

export default component.exports